import React from 'react'

import Layout from 'components/shared/Layout'
import FeaturesList from 'components/shared/FeaturesList'

import classnames from 'classnames/bind'
import css from './styles.module.scss'

const cx = classnames.bind(css)

const FeaturesSlice = ({ cards, className, title, layout, iconLayout }) => {
  return (
    <Layout
      className={cx(css.FeaturesSlice, className)}
      tag="section"
      type="maxWidth"
    >
      <Layout type="wrapper">
        {cards && (
          <FeaturesList
            iconLayout={iconLayout}
            layout={layout}
            cards={cards}
            title={title}
          />
        )}
      </Layout>
    </Layout>
  )
}

export default FeaturesSlice
